"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.send = exports.del = exports.post = exports.put = exports.get = exports.deleteSub = exports.putSub = exports.deleteRelation = exports.postRelation = exports.putEntityOrganization = exports.putAccessibility = exports.deletePermission = exports.postPermission = exports.getConfiguration = exports.configuration = void 0;

var axios_1 = require("axios");

function _send(authentication, method, pathOrUrl, queryParameters, body) {
  return __awaiter(this, void 0, void 0, function () {
    var accessToken, tenantId, headers, query, querystring, url, response, text, json, error_1, errorResponse, _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          accessToken = authentication.accessToken, tenantId = authentication.tenantId;

          if (!exports.configuration.apiRoot) {
            throw new Error('Configuration root is not set');
          }

          _b.label = 1;

        case 1:
          _b.trys.push([1, 6,, 14]);

          headers = {
            'Content-Type': 'application/json'
          };

          if (tenantId) {
            headers['Tenant'] = tenantId;
          }

          if (accessToken) {
            // Todo Handle refresh token and make it possible to update them in the redux store
            // if (clientId && refreshToken && expires < Date.now() / 1000) {
            //   const result = await refreshTokens(clientId, refreshToken);
            // }
            headers[(exports.configuration === null || exports.configuration === void 0 ? void 0 : exports.configuration.authorizationHeader) || 'Authorization'] = "Bearer " + accessToken;
          }

          query = queryParameters && Object.entries(queryParameters).filter(function (_a) {
            var value = _a[1];
            return value !== undefined;
          }).map(function (_a) {
            var key = _a[0],
                value = _a[1];
            return Array.isArray(value) ? value.map(function (v) {
              return key + "=" + v;
            }).join('&') : key + "=" + value;
          }).join('&');
          querystring = query ? '?' + query : '';
          url = pathOrUrl.indexOf('http') === 0 ? pathOrUrl + querystring : exports.configuration.apiRoot + pathOrUrl + querystring;
          return [4
          /*yield*/
          , axios_1.default({
            url: url,
            method: method,
            headers: headers,
            data: body
          })];

        case 2:
          response = _b.sent();

          if (response.status === 401) {
            window.open((exports.configuration.loginPath || '/login') + "?returnurl=" + window.location.href, '_self');
            return [2
            /*return*/
            , {
              httpStatusCode: 401,
              isSuccess: false
            }];
          }

          if (!(response.status === 500)) return [3
          /*break*/
          , 4];
          return [4
          /*yield*/
          , response.data];

        case 3:
          text = _b.sent();
          console.error(text);
          return [2
          /*return*/
          , {
            httpStatusCode: 500,
            message: text,
            isSuccess: false
          }];

        case 4:
          return [4
          /*yield*/
          , response.data];

        case 5:
          json = _b.sent();
          return [2
          /*return*/
          , __assign(__assign({}, json), {
            isSuccess: true
          })];

        case 6:
          error_1 = _b.sent();
          if (!error_1.response) return [3
          /*break*/
          , 12];
          errorResponse = error_1.response;
          _a = error_1.response.status;

          switch (_a) {
            case 401:
              return [3
              /*break*/
              , 7];
          }

          return [3
          /*break*/
          , 10];

        case 7:
          if (!exports.configuration.handleUnauthorized) return [3
          /*break*/
          , 9];
          return [4
          /*yield*/
          , exports.configuration.handleUnauthorized(error_1)];

        case 8:
          return [2
          /*return*/
          , _b.sent()];

        case 9:
          if (exports.configuration.loginPath) {
            window.open(exports.configuration.loginPath + "?returnurl=" + window.location.href, '_self');
            return [2
            /*return*/
            , {
              httpStatusCode: 301,
              message: 'Require sign in'
            }];
          }

          return [2
          /*return*/
          , {
            httpStatusCode: errorResponse.status,
            message: errorResponse.statusText
          }];

        case 10:
          return [2
          /*return*/
          , {
            httpStatusCode: errorResponse.status,
            message: errorResponse.statusText
          }];

        case 11:
          return [3
          /*break*/
          , 13];

        case 12:
          throw error_1;

        case 13:
          return [3
          /*break*/
          , 14];

        case 14:
          return [2
          /*return*/
          ];
      }
    });
  });
}

exports.configuration = {
  send: _send,
  urls: {}
};

var getConfiguration = function getConfiguration() {
  return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , fetch('/configuration')];

        case 1:
          response = _a.sent();
          return [4
          /*yield*/
          , response.json()];

        case 2:
          return [2
          /*return*/
          , _a.sent()];
      }
    });
  });
};

exports.getConfiguration = getConfiguration;

var postPermission = function postPermission(authentication, basePath, id, permission) {
  return exports.send(authentication, 'POST', basePath + id + '/permissions', undefined, JSON.stringify(permission));
};

exports.postPermission = postPermission;

var deletePermission = function deletePermission(authentication, basePath, id, permissionId) {
  return exports.deleteSub(authentication, basePath, id, 'permissions', permissionId);
};

exports.deletePermission = deletePermission;

var putAccessibility = function putAccessibility(authentication, basePath, id, accessibility) {
  return exports.putSub(authentication, basePath, id, 'accessibility', {
    accessibility: accessibility
  });
};

exports.putAccessibility = putAccessibility;

var putEntityOrganization = function putEntityOrganization(authentication, basePath, id, organizationId) {
  return exports.putSub(authentication, basePath, id, 'organization', {
    organizationId: organizationId
  });
};

exports.putEntityOrganization = putEntityOrganization;

var postRelation = function postRelation(authentication, basePath, id, relation) {
  return exports.send(authentication, 'POST', basePath + id + '/relations', undefined, JSON.stringify(relation));
};

exports.postRelation = postRelation;

var deleteRelation = function deleteRelation(authentication, basePath, id, relationId) {
  return exports.deleteSub(authentication, basePath, id, 'relations', relationId);
};

exports.deleteRelation = deleteRelation;

var putSub = function putSub(authentication, basePath, id, sub, data) {
  return exports.send(authentication, 'PUT', basePath + id + '/' + sub, undefined, JSON.stringify(data));
};

exports.putSub = putSub;

var deleteSub = function deleteSub(authentication, basePath, id, sub, subId) {
  return exports.del(authentication, basePath + id + '/' + sub + '/' + subId);
};

exports.deleteSub = deleteSub;

function get(authentication, path, queryParameters) {
  return __awaiter(this, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , exports.send(authentication, 'GET', path, queryParameters)];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , response];
      }
    });
  });
}

exports.get = get;

function put(authentication, path, data) {
  return __awaiter(this, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , exports.send(authentication, 'PUT', path, undefined, data && JSON.stringify({
            data: data
          }))];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , response];
      }
    });
  });
}

exports.put = put;

function post(authentication, path, data) {
  return __awaiter(this, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , exports.send(authentication, 'POST', path, undefined, data && JSON.stringify({
            data: data
          }))];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , response];
      }
    });
  });
}

exports.post = post;

var del = function del(authentication, path) {
  return exports.send(authentication, 'DELETE', path);
};

exports.del = del;

var send = function send(authentication, method, path, queryParameters, body) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , (exports.configuration === null || exports.configuration === void 0 ? void 0 : exports.configuration.send) ? exports.configuration.send(authentication, method, path, queryParameters, body) : undefined];
    });
  });
};

exports.send = send;